import { render, staticRenderFns } from "./ContentDesignEdit.vue?vue&type=template&id=38a02c2a&scoped=true&"
import script from "./ContentDesignEdit.vue?vue&type=script&lang=js&"
export * from "./ContentDesignEdit.vue?vue&type=script&lang=js&"
import style0 from "./ContentDesignEdit.vue?vue&type=style&index=0&id=38a02c2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a02c2a",
  null
  
)

export default component.exports